module.exports = __webpack_public_path__ + "img/bfp-logo.1ba5d2fd.svg";